<template>
  <div
    class="related-to-link"
    :class="{ clickable: linkPath }"
    @click="handleClick"
  >
    <v-img
      :src="
        require(`@/assets/svg/${parentResourceName}_icon${
          linkPath ? '_clickable' : ''
        }.svg`)
      "
      class="related-to-link-icon"
    />
    <span class="ml-2">
      {{ text }}
    </span>
  </div>
</template>

<script>
export default {
  name: "RelatedToLink",
  data() {
    return {};
  },
  props: {
    entityType: {
      type: String,
      required: true
    },
    text: {
      type: String,
      required: true
    },
    linkPath: String
  },
  computed: {
    parentResourceName() {
      return this.entityType === "booking" ? "booking" : "offer";
    }
  },
  methods: {
    handleClick() {
      if (this.linkPath) {
        this.$router.replace(this.linkPath);
      }
    }
  }
};
</script>

<style lang="scss">
.related-to-link {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding: 2px;
  width: fit-content;
  font-style: italic;

  &.clickable {
    font-style: normal;
    color: $primary-darker;
    font-weight: bold;
  }

  .related-to-link-icon {
    max-width: 20px;
    max-height: 20px;
  }
}
</style>
